import {orderBy} from 'lodash'
import React from 'react'
import SelectGroup from './select-group'
import ListBox from '../listbox'
import ListBoxActions from '../listbox/listbox-actions'
import Text from 'react-text'
import './groups-step.styl'

function makeStudentClickHandler ({props, target}) {
  return ({id, selected}) =>
    props.setState({[target]: props[target].map(student => (
      student.id != id
        ? student
        : {...student, selected: !selected}
    ))})
}

export default function GroupsStep(props) {

  const groupClick = (group) => {
    if (group.id != props.selectedGroup.id) {
      props.setState({
        selectedGroup: group,
        selectedStudents: [],
        studentList: group.students.map(student => ({...student, selected: false}))
      })
    }
  }

  return (
    <div className="groups-step">
       <div className="groups-message">
         <Text id='schedule_lesson_groups_instructions' />
       </div>

       <div className="student-selector">
         <SelectGroup selectedGroup={props.selectedGroup} onClick={groupClick} />
         <ListBox
           className= "select-student"
           labelId= "students_label"
           items= {orderBy(props.studentList, ['name'])}
           onClick = {makeStudentClickHandler({props, target: 'studentList'})}
         />
         <ListBoxActions
           onAllLeft={() => {
            const studentList = props.studentList.concat(props.selectedStudents)
            props.setState({selectedStudents: [], studentList})
           }}
           onLeft={() => {
            const selectedStudents = props.selectedStudents.filter(({selected}) => !selected)
            const studentList = props.studentList.concat(props.selectedStudents.filter(({selected}) => selected))
            props.setState({selectedStudents, studentList})
           }}
           onRight={() => {
            const studentList = props.studentList.filter(({selected}) => !selected)
            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({selected}) => selected))
            props.setState({selectedStudents, studentList})
           }}
           onAllRight={() => {
            const selectedStudents = props.selectedStudents.concat(props.studentList)
            props.setState({selectedStudents, studentList:[]})
           }}
         />
        <ListBox
          className= "selected-students"
          labelId= "selection_label"
          items= {orderBy(props.selectedStudents, ['name'])}
          onClick = {makeStudentClickHandler({props, target: 'selectedStudents'})}
        />
    </div>
  </div>)
}
